<ng-container *ngIf="this.isLive && (('IsBetStopReasonHeader' | getEnv) || ('IsBetStopReasonMatchRow' | getEnv)) && this.isShowEvent; else isBetActive">
  <ng-container *ngIf="('IsBetStopReasonHeader' | getEnv) && this.page === 'header'">
    <div class="betStop-reason-header-main">
      <div
        class="betStop-reason-header-homeTeam"
        [ngClass]="{
          'betStop-reason-header-score-change': this.eventType === 4
        }">
        <div class="betStop-reason-header-homeTeam-text">{{ this.homeTeamName }}</div>
        <div class="betStop-reason-header-homeTeam-score">{{ this.homeTeamScore }}</div>
      </div>
      <div class="divider-score">-</div>
      <div
        class="betStop-reason-header-awayTeam"
        [ngClass]="{
          'betStop-reason-header-score-change': this.eventType === 5
        }">
        <div class="betStop-reason-header-awayTeam-score">{{ this.awayTeamScore }}</div>
        <div class="betStop-reason-header-awayTeam-text">{{ this.awayTeamName }}</div>
      </div>
      <div class="box logo-container" [routerLink]="['/home']" style="position: absolute; transform: translate(0px, -70px)">
        <image-loader-utils extraClasses="logo" url="logo" [shared]="false" imageFormat="png"></image-loader-utils>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="('IsBetStopReasonMatchRow' | getEnv) && this.page === 'matchRow'">
    <div [class]="'betStop-reason-main' + ' ' + this.extraStyle">
      <div class="gradient-border">
        <div class="gradient-border-content">
          <div class="svg-container">
            <image-loader-utils [url]="this.eventIcon" extraClasses="soccer-svg"></image-loader-utils>
          </div>
          <div class="gradient-border-text website">
            <div class="gradient-border-text-left">
              {{ this.eventName | translate }}
            </div>
            <div [class]="'gradient-border-text-right animation-' + ((this.teamName !== 'none' ? 1 : 0) + (this.isScore ? 1 : 0))">
              <ng-container *ngIf="this.teamName !== 'none'">
                <div class="animation-container first-text">
                  <div class="textContainer">
                    <p>{{ this.teamName }}</p>
                  </div>
                </div>
              </ng-container>
              <ng-container *ngIf="this.isScore">
                <div class="animation-container second-text">
                  <div class="textContainer">
                    <p>{{ this.eventScore }}</p>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
          <div class="gradient-border-text mobile">
            <div [class]="'gradient-border-text-right animation-' + ((this.teamName !== 'none' ? 1 : 0) + (this.isScore ? 1 : 0))">
              <div class="animation-container first-text">
                <div class="textContainer">
                  <p style="white-space: normal !important">{{ this.eventName | translate }}</p>
                </div>
              </div>
              <ng-container *ngIf="this.teamName !== 'none'">
                <div class="animation-container first-text">
                  <div class="textContainer">
                    <p>{{ this.teamName }}</p>
                  </div>
                </div>
              </ng-container>
              <ng-container *ngIf="this.isScore">
                <div class="animation-container second-text">
                  <div class="textContainer">
                    <p>{{ this.eventScore }}</p>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="('IsBetStopReasonMatchRow' | getEnv) && this.page === 'myBets'">
    <div [class]="'livetracker-betStop-main' + ' ' + this.extraStyle">
      <div class="gradient-border">
        <div class="gradient-border-content">
          <div class="svg-container">
            <image-loader-utils [url]="this.eventIcon" extraClasses="soccer-svg"></image-loader-utils>
          </div>
          <div class="gradient-border-text website">
            <div class="gradient-border-text-left">
              {{ this.eventName | translate }}
            </div>
            <div [class]="'gradient-border-text-right animation-' + ((this.teamName !== 'none' ? 1 : 0) + (this.isScore ? 1 : 0))">
              <ng-container *ngIf="this.teamName !== 'none'">
                <div class="animation-container first-text">
                  <div class="textContainer">
                    <p>{{ this.teamName }}</p>
                  </div>
                </div>
              </ng-container>
              <ng-container *ngIf="this.isScore">
                <div class="animation-container second-text">
                  <div class="textContainer">
                    <p>{{ this.eventScore }}</p>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
          <div class="gradient-border-text mobile">
            <div [class]="'gradient-border-text-right animation-' + ((this.teamName !== 'none' ? 1 : 0) + (this.isScore ? 1 : 0))">
              <div class="animation-container first-text">
                <div class="textContainer">
                  <p style="white-space: normal !important">{{ this.eventName | translate }}</p>
                </div>
              </div>
              <ng-container *ngIf="this.teamName !== 'none'">
                <div class="animation-container first-text">
                  <div class="textContainer">
                    <p>{{ this.teamName }}</p>
                  </div>
                </div>
              </ng-container>
              <ng-container *ngIf="this.isScore">
                <div class="animation-container second-text">
                  <div class="textContainer">
                    <p>{{ this.eventScore }}</p>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</ng-container>
<ng-template #isBetActive>
  <ng-content></ng-content>
</ng-template>
